import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Splash() {
    const [ready, setReady] = useState(false);
    useEffect(() => {
        const t = setTimeout(() => setReady(true), 80);
        return () => clearTimeout(t);
    }, []);

    const fireflies = Array.from({ length: 14 }).map((_, i) => ({
        id: i,
        left: `${(i * 71 + 13) % 100}%`,
        top: `${(i * 47 + 22) % 100}%`,
        delay: `${(i % 7) * 0.5}s`,
        duration: `${4 + (i % 5)}s`,
    }));

    return (
        <div className="relative min-h-screen w-full overflow-hidden bg-black splash-root" data-testid="splash-page">
            {/* Reference background — has logo, title, "Promise", tagline baked in */}
            <img
                src="/img/splash_bg.png"
                alt="Poppa and Gigi's Promise — Stories Woven In Grain"
                className={`absolute inset-0 w-full h-full object-cover object-center select-none transition-all duration-[2400ms] ease-out ${
                    ready ? "opacity-100 splash-ken-burns" : "opacity-0 scale-105"
                }`}
                draggable={false}
            />

            {/* Soft vignette so the ENTER button reads clearly */}
            <div className="absolute inset-0 pointer-events-none" style={{
                background: "radial-gradient(ellipse at 50% 88%, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.15) 35%, rgba(0,0,0,0) 65%)"
            }} />

            {/* Cinematic fade-in overlay (covers everything then fades out) */}
            <div
                className={`absolute inset-0 bg-black pointer-events-none transition-opacity duration-[1600ms] ease-out ${
                    ready ? "opacity-0" : "opacity-100"
                }`}
            />

            {/* Floating fireflies — fade in after main reveal */}
            <div className={`transition-opacity duration-[1200ms] delay-[1200ms] ${ready ? "opacity-100" : "opacity-0"}`}>
                {fireflies.map((f) => (
                    <span
                        key={f.id}
                        className="firefly animate-firefly pointer-events-none"
                        style={{ left: f.left, top: f.top, animationDelay: f.delay, animationDuration: f.duration }}
                    />
                ))}
            </div>

            {/* Clickable ENTER hotspot — positioned over the reference's "ENTER" text. Delayed reveal. */}
            <div
                className={`absolute inset-x-0 bottom-[6%] sm:bottom-[8%] flex justify-center transition-all duration-[1000ms] delay-[1600ms] ease-out ${
                    ready ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"
                }`}
            >
                <Link
                    to="/home"
                    data-testid="splash-enter-button"
                    aria-label="Enter the site"
                    className="group relative inline-flex items-center justify-center w-44 sm:w-56 h-12 sm:h-14 rounded-full cursor-pointer transition-transform duration-500 hover:scale-[1.06]"
                >
                    <span
                        aria-hidden="true"
                        className="absolute inset-0 rounded-full border border-white/70 opacity-80 group-hover:opacity-100 animate-ping"
                        style={{ animationDuration: "2.8s" }}
                    />
                    <span
                        aria-hidden="true"
                        className="absolute inset-0 rounded-full border border-white/60 opacity-0 group-hover:opacity-90 transition-opacity"
                    />
                    <span
                        aria-hidden="true"
                        className="absolute inset-0 rounded-full bg-white/0 group-hover:bg-white/10 transition-colors"
                    />
                    <span className="sr-only">Enter</span>
                </Link>
            </div>
        </div>
    );
}
